
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/list",
      function () {
        return require("private-next-pages/partners/list.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/list"])
      });
    }
  